import React from 'react';
import Header from './Header';
import WritingTools from './WritingTools';

const WritersRoom = ({ 
  onNavigateToHome, 
  onNavigateToCourses, 
  onNavigateToProfile, 
  onNavigateToPrompts, 
  onNavigateToWritersRoom,
  onLogOut, 
  onModeSwitch, 
  showAdminMode 
}) => {
  return (
    <>
      <Header 
        title="Writers Room"
        onNavigateToHome={onNavigateToHome}
        onNavigateToCourses={onNavigateToCourses}
        onNavigateToProfile={onNavigateToProfile}
        onNavigateToPrompts={onNavigateToPrompts}
        onNavigateToWritersRoom={onNavigateToWritersRoom}
        onLogOut={onLogOut}
        onModeSwitch={onModeSwitch}
        showAdminMode={showAdminMode}
      />
      <WritingTools />
    </>
  );
};

export default WritersRoom;

